<template>
  <component
    :is="item.routeName ? 'router-link' : 'div'"
    ref="newsWidgetLauncher"
    :to="item.routeName ? { name: item.routeName } : null"
    :active-class="$style.isActive"
    :class="[
      { [$style.mainItem]: mainItem, [$style.secondaryItem]: !mainItem }
    ]"
    @click="close"
    v-test="item.isNewsWidget ? 'nav-new-features' : `nav-main-${item.routeName || item.name}`"
  >
    <BaseIcon
      :name="item.icon"
      color="inverted"
      :size="!mainItem ? 's' : 'm'"
    />
    <Flex
      align="center"
      :gap="0.5"
    >
      <BaseText color="inverted">{{ item.name }}</BaseText>
      <BaseNotification
        v-if="item.notification && item.notification.show"
        v-test="`nav-main-notification-${item.routeName}`"
      >
        {{ item.notification.value }}
      </BaseNotification>
    </Flex>
  </component>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import productFruitsService from '@/product-fruits';
import { usePageLayoutStore } from '@/stores/page-layout';
import type { NavItem } from './MobileOverlay.vue';

const { showMobileMenu } = storeToRefs(usePageLayoutStore());

const close = () => (showMobileMenu.value = false);

const props = defineProps<{
  item: NavItem;
  mainItem?: boolean;
}>();

const newsWidgetLauncher = ref<{ $el: HTMLElement } | HTMLElement>();

onMounted(() => {
  if (!props.item.isNewsWidget || !newsWidgetLauncher.value) {
    return;
  }

  const el =
    '$el' in newsWidgetLauncher.value
      ? newsWidgetLauncher.value.$el
      : newsWidgetLauncher.value;
  productFruitsService.attachNewsWidget(el);
});
</script>

<style
  lang="scss"
  module
>
.secondaryItem {
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  padding: 1.7vh $spacing;
  gap: $spacing;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(191, 191, 191, 0.4);
  }

  @media (max-height: 710px) {
    padding: 1.3vh $spacing;
  }
  @media (max-height: 620px) {
    padding: 1vh $spacing;
  }

  &:focus {
    background: var(--color-primary-dark);
  }

  @include hover {
    background: var(--color-primary);
  }
}

.mainItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $spacing;
  gap: 0.25 * $spacing;
  flex-basis: 33%;
  background: var(--surface-nav);
  border: 1px solid var(--color-primary-dark);
  border-radius: $radius;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);

  // Same as the desktop nav in dark mode
  @include theme('dark') {
    border-color: var(--border);
  }
}
</style>
